import requestUtils from 'api/requestUtils'
import { paths } from '@luxuryescapes/contract-business'

type CalculatedBusinessBudgetServerResponse = paths['/api/business-traveller/businesses/{businessId}/calculated-budget']['get']['responses'][200]['content']['application/json']

function mapCalculatedBusinessBudget(serverData: CalculatedBusinessBudgetServerResponse['result']): BusinessTraveller.BusinessBudget {
  const mappedBudget: BusinessTraveller.BusinessBudget = {
    totalBudget: serverData.totalBudget,
  }
  if (serverData.nightlyBudget) {
    mappedBudget.nightlyBudget = serverData.nightlyBudget
  }
  return mappedBudget
}

interface Params {
  businessId: string;
  toBeCalculatedBusinessBudget: BusinessTraveller.ToBeCalculatedBusinessBudget
}

async function requestGetCalculatedBusinessBudget(params: Params) {
  const { businessId, toBeCalculatedBusinessBudget } = params
  const { itemPolicyType, numberOfNights, currencyCode, lePlaceId, longitude, latitude } = toBeCalculatedBusinessBudget

  try {
    let urlParams = `?policyType=${itemPolicyType}&numberOfNights=${numberOfNights}&currencyCode=${currencyCode}`
    if (lePlaceId) {
      urlParams += `&lePlaceId=${lePlaceId}`
    }
    if (longitude && latitude) {
      urlParams += `&longitude=${longitude}&latitude=${latitude}`
    }

    const response = await requestUtils.get<CalculatedBusinessBudgetServerResponse>(
      `/api/business-traveller/businesses/${businessId}/calculated-budget${urlParams}`,
      { credentials: 'include' },
    )
    return mapCalculatedBusinessBudget(response.result)
  } catch (error) {
    return Promise.reject(error)
  }
}

export default requestGetCalculatedBusinessBudget
